import { Modal, ProgressBar } from '../../../components/BootstrapToMUI';
import '../../items/formFields.css';
import { useState, useEffect } from 'react';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import RemoveIcon from '@mui/icons-material/Remove';
import AddIcon from '@mui/icons-material/Add';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import SendIcon from '@mui/icons-material/Send';
import { v4 as uuidv4 } from 'uuid';
import request from '../../../services/Request';
import Swal from 'sweetalert2';
import { Select, MenuItem, FormControl, InputLabel, Box, Typography, alpha } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const SSURL = '/screenSaver/create';

export default function CreateSS(props) {
  const theme = useTheme();
  const [name, setName] = useState('');
  const [counter, setCounter] = useState('5');
  const [e1, setE1] = useState('');
  const [e2, setE2] = useState('');
  const [percent, setPercent] = useState(0);
  const [formData, setFormData] = useState(new FormData());
  const [inputFields, setInputFields] = useState([{ id: uuidv4(), file: '', promo: '' }]);

  const cleanUP = () => {
    setName('');
    setFormData(new FormData());
    setInputFields([{ id: uuidv4(), file: '' }]);
    setPercent(0);
    setE1('');
    setE2('');
    setCounter('5');
  };

  useEffect(() => {
    cleanUP();
  }, [props.show]);

  const handlePromoChange = (index, e) => {
    const { value } = e.target;
    const list = [...inputFields];
    list[index].promo = value;
    setInputFields(list);
    console.log(list);
  };

  const onSubmit = async (e) => {
    let go = true;
    if (name === '') {
      setE1('Please enter a name for your screen saver');
      go = false;
    }
    if (!inputFields[0].file) {
      setE2('Screen saver must contain at least one picture or video');
      go = false;
    }
    for (var value of formData.values()) {
      console.log(value);
    }
    formData.set('fields', JSON.stringify(inputFields));
    e.preventDefault();
    if (go) {
      formData.set('name', name);
      formData.set('interval', counter);
      await request({
        method: 'post',
        url: SSURL,
        data: formData,
        onUploadProgress: (progressEvent) => {
          const { loaded, total } = progressEvent;
          let percent = Math.floor((loaded * 100) / total);
          if (percent < 100) {
            setPercent(percent);
          }
        },
      })
        .then((res) => {
          setPercent(100, () => {
            setTimeout(() => {
              setPercent(0);
            }, 1000);
          });
          Swal.fire({
            text: `New screen Saver has been successfully created`,
            icon: 'success',
          }).then(() => {
            props.onHide();
            props.reflesh ? props.setReflesh(false) : props.setReflesh(true);
          });
        })
        .catch((err) => {
          Swal.fire({
            text: err.response?.data?.message,
            icon: 'error',
          });
          console.log(err.response.data.message);
          setE2(err.response.data.message);
        });
    }
  };

  const onFileChange = (id, e) => {
    setPercent(0);
    formData.set('referTo', props._id);
    if (e.target.files[0]) {
      setE2('');
      const newInputFields = inputFields.map((i) => {
        if (id === i.id) {
          var FormValues = formData.getAll('picture');
          console.log(FormValues);
          var index = FormValues.findIndex((e) => id === e.name.split('.').slice(0, -1).join('.'));
          if (index > -1) {
            FormValues.splice(index, 1);
            formData.delete('picture');
            console.log(FormValues);
            FormValues.forEach((e) => {
              formData.append('picture', e);
            });
          }
          const extention = e.target.files[0].name.split('.').pop();
          formData.append('picture', e.target.files[0], `${e.target.files[0].name}`);
          i.file = e.target.files[0].name;
          // formData.set('id', e.target.files[0]);
          // i.file = e.target.files[0].name
        }
        return i;
      });
      setInputFields(newInputFields);
    }
  };

  const handleAddFields = () => {
    setInputFields([...inputFields, { id: uuidv4(), file: null }]);
  };

  const handleRemoveFields = (id) => {
    console.log(id);
    const values = [...inputFields];
    values.splice(
      values.findIndex((value) => value.id === id),
      1
    );
    setInputFields(values);
    var FormValues = formData.getAll('picture');
    console.log(FormValues);
    var i = FormValues.findIndex((e) => id === e.name.split('.').slice(0, -1).join('.'));
    if (i > -1) {
      FormValues.splice(i, 1);
      formData.delete('picture');
      console.log(FormValues);
      FormValues.forEach((e) => {
        formData.append('picture', e);
      });
    }
    console.log(i);
  };

  return (
    <Modal className="modal-w" {...props} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">Add New Screen Saver</Modal.Title>
      </Modal.Header>
      <Modal.Body className="modal-body">
        <Box component="form" onSubmit={onSubmit} sx={{ p: 2 }}>
          <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
            <TextField
              name="name"
              label="Name"
              variant="outlined"
              value={name}
              fullWidth
              onChange={(e) => {
                e.target.value === '' ? setE1('Please enter a name for your screen saver') : setE1('');
                setName(e.target.value);
              }}
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: 2,
                },
              }}
            />
            <TextField
              sx={{
                minWidth: 200,
                '& .MuiOutlinedInput-root': {
                  borderRadius: 2,
                },
              }}
              name="counter"
              label="Interval (seconds)"
              variant="outlined"
              type="number"
              value={counter}
              inputProps={{
                step: '0.1',
                min: '0',
                max: '100',
              }}
              onChange={(e) => {
                e.target.value === '' ? setE1('Please enter a name for your screen saver') : setE1('');
                setCounter(e.target.value);
              }}
            />
          </Box>

          {e1 !== '' && (
            <Typography variant="caption" sx={{ color: theme.palette.error.main, display: 'block', mb: 2 }}>
              {e1}
            </Typography>
          )}

          {inputFields.length > 0 &&
            inputFields.map((inputField, index) => (
              <Box
                key={inputField.id}
                sx={{
                  mb: 2,
                  p: 2,
                  borderRadius: 2,
                  border: `1px solid ${alpha(theme.palette.divider, 0.2)}`,
                  backgroundColor: alpha(theme.palette.background.paper, 0.5),
                }}
              >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
                  <Button
                    variant="contained"
                    component="label"
                    startIcon={<CloudUploadIcon />}
                    sx={{
                      borderRadius: 2,
                      textTransform: 'none',
                      fontWeight: 600,
                      background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
                    }}
                  >
                    Upload
                    <input
                      type="file"
                      name="file"
                      accept=".mp4,.jpg,.png,.jpeg"
                      onChange={(event) => onFileChange(inputField.id, event)}
                      hidden
                    />
                  </Button>
                  <Typography
                    variant="body2"
                    sx={{
                      flex: 1,
                      color: theme.palette.text.secondary,
                      fontFamily: 'monospace',
                      fontSize: '0.85rem',
                    }}
                  >
                    {inputField.file || 'No file selected'}
                  </Typography>
                  <IconButton
                    disabled={inputFields.length === 1}
                    onClick={() => handleRemoveFields(inputField.id)}
                    size="small"
                    sx={{
                      color: theme.palette.error.main,
                      '&:hover': {
                        backgroundColor: alpha(theme.palette.error.main, 0.1),
                      },
                    }}
                  >
                    <RemoveIcon />
                  </IconButton>
                  <IconButton
                    onClick={handleAddFields}
                    size="small"
                    sx={{
                      color: theme.palette.success.main,
                      '&:hover': {
                        backgroundColor: alpha(theme.palette.success.main, 0.1),
                      },
                    }}
                  >
                    <AddIcon />
                  </IconButton>
                </Box>
                <FormControl fullWidth>
                  <InputLabel id={`promo-label-${index}`}>
                    Link a promotion (optional)
                  </InputLabel>
                  <Select
                    labelId={`promo-label-${index}`}
                    value={inputField.promo}
                    variant="outlined"
                    onChange={(e) => handlePromoChange(index, e)}
                    label="Link a promotion (optional)"
                    sx={{
                      borderRadius: 2,
                    }}
                  >
                    <MenuItem value="">None</MenuItem>
                    {props.promo?.map((e) => (
                      <MenuItem key={e._id} value={e._id}>{e.title}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
            ))}

          {e2 !== '' && (
            <Typography variant="caption" sx={{ color: theme.palette.error.main, display: 'block', mb: 2 }}>
              {e2}
            </Typography>
          )}

          {percent > 0 && (
            <Box sx={{ mb: 2 }}>
              <ProgressBar now={percent} label={`${percent}%`} />
            </Box>
          )}

          <Typography variant="caption" sx={{ color: theme.palette.text.secondary, display: 'block', mb: 1 }}>
            Images and Videos must be 1920 (h) x 1080 (w) pixels.
          </Typography>
          <Typography variant="caption" sx={{ color: theme.palette.text.secondary, display: 'block', mb: 2 }}>
            Only jpeg, jpg, png and mp4 are accepted. Total files size cannot exceed 100MB.
          </Typography>

          <Button
            variant="contained"
            color="primary"
            type="submit"
            fullWidth
            endIcon={<SendIcon />}
            onClick={onSubmit}
            sx={{
              borderRadius: 2,
              py: 1.5,
              textTransform: 'none',
              fontWeight: 600,
              background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
              boxShadow: `0 4px 12px ${alpha(theme.palette.primary.main, 0.4)}`,
              '&:hover': {
                boxShadow: `0 6px 20px ${alpha(theme.palette.primary.main, 0.5)}`,
              },
            }}
          >
            Submit
          </Button>
        </Box>
      </Modal.Body>
    </Modal>
  );
}
